// EventCalendar.js
import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./EventCalendar.scss";

const EventCalendar = () => {
  const today = new Date();

  const [currentDate, setCurrentDate] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1)
  );

  const [selectedEvent, setSelectedEvent] = useState(null);

  // Random Colors
  const colors = [
    "#00c8ff",
    "#ff6b6b",
    "#6c5ce7",
    "#00b894",
    "#fdcb6e",
    "#e84393",
    "#0984e3",
    "#ff9f43",
  ];

  // Events
  const events = [
    {
      id: 1,
      date: "2026-06-03",
      title: "Collecting Funds for Kids",
      description: "Fund collection event for children support.",
      color: colors[0],
    },
    {
      id: 2,
      date: "2026-06-10",
      title: "School Meeting",
      description: "Monthly parent and teacher meeting.",
      color: colors[1],
    },
    {
      id: 3,
      date: "2026-06-12",
      title: "Sports Day",
      description: "Annual sports competition.",
      color: colors[2],
    },
    {
      id: 4,
      date: "2026-06-15",
      title: "Science Exhibition",
      description: "Students science projects showcase.",
      color: colors[3],
    },
    {
      id: 5,
      date: "2026-06-24",
      title: "Holiday Celebration",
      description: "Special holiday celebration program.",
      color: colors[4],
    },
  ];

  const month = currentDate.getMonth();
  const year = currentDate.getFullYear();

  const firstDay = new Date(year, month, 1).getDay();
  const totalDays = new Date(year, month + 1, 0).getDate();

  const prevMonthDays = new Date(year, month, 0).getDate();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

  const changeMonth = (direction) => {
    setSelectedEvent(null);

    setCurrentDate(
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + direction,
        1
      )
    );
  };

  const formatDate = (day) => {
    return `${year}-${String(month + 1).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
  };

  const getEvents = (day) => {
    const fullDate = formatDate(day);
    return events.filter((event) => event.date === fullDate);
  };

  // Current Today Check
  const isToday = (day) => {
    return (
      today.getDate() === day &&
      today.getMonth() === month &&
      today.getFullYear() === year
    );
  };

  // Click Day
  const handleDayClick = (day) => {
    const dayEvents = getEvents(day);

    if (dayEvents.length > 0) {
      // Show only clicked event date events
      setSelectedEvent(dayEvents);
    } else {
      setSelectedEvent(null);
    }
  };

  const renderCalendar = () => {
    const cells = [];

    // Previous Month Days
    for (let i = firstDay - 1; i >= 0; i--) {
      cells.push(
        <div className="calendar-cell disabled" key={`prev-${i}`}>
          {prevMonthDays - i}
        </div>
      );
    }

    // Current Month Days
    for (let day = 1; day <= totalDays; day++) {
      const dayEvents = getEvents(day);

      cells.push(
        <div
          className={`calendar-cell ${
            isToday(day) ? "today-cell" : ""
          }`}
          key={day}
          onClick={() => handleDayClick(day)}
        >
          <div className="day-number">{day}</div>

          {dayEvents.length > 0 && (
            <div className="event-dots">
              {dayEvents.map((event, index) => (
                <span
                  key={index}
                  className="event-dot"
                  style={{
                    background: event.color,
                  }}
                ></span>
              ))}
            </div>
          )}
        </div>
      );
    }

    return cells;
  };

  return (
    <div className="calendar-wrapper position-relative">
      {/* Header */}
      <div className="calendar-header d-flex justify-content-between align-items-center">
        <button
          className="nav-btn"
          onClick={() => changeMonth(-1)}
        >
          <i className="bi bi-caret-left-fill"></i>
        </button>

        <h5 className="m-0">
          {monthNames[month]} {year}
        </h5>

        <button
          className="nav-btn"
          onClick={() => changeMonth(1)}
        >
          <i className="bi bi-caret-right-fill"></i>
        </button>
      </div>

      {/* Days */}
      <div className="day-names">
        {dayNames.map((day) => (
          <div key={day} className="day-name">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar */}
      <div className="calendar-grid">{renderCalendar()}</div>

      {/* Event List */}
      {/* <div className="event-section">
        <h6 className="event-title">
          <span className="event-box"></span>
          Upcoming Events
        </h6>

        {events
          .filter((e) => {
            const eventDate = new Date(e.date);

            return (
              eventDate.getMonth() === month &&
              eventDate.getFullYear() === year
            );
          })
          .map((event, index) => (
            <div
              className="event-item"
              key={index}
              onClick={() => setSelectedEvent([event])}
            >
              <span
                className="event-dot"
                style={{
                  background: event.color,
                  width: "10px",
                  height: "10px",
                }}
              ></span>

              {event.title}
            </div>
          ))}
      </div> */}

      {/* Tooltip */}
      {selectedEvent && (
        <div className="event-tooltip">
          {selectedEvent.map((event, index) => (
            <div key={index} className="tooltip-event">
              <div
                className="tooltip-color"
                style={{
                  background: event.color,
                }}
              ></div>

              <h6>{event.title}</h6>

              <p>{event.description}</p>

              <small>
                <i className="bi bi-calendar-event me-1"></i>
                {event.date}
              </small>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EventCalendar;